import Header from "@/components/Header";
import HomeHero from "@/components/HomeHero";
import Hero from "@/components/Hero";
import SparkSection from "@/components/SparkSection";
import AboutSection from "@/components/AboutSection";
import PoemSection from "@/components/PoemSection";
import ProgramsSection from "@/components/ProgramsSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const Index = () => {
  return (
    <div className="min-h-screen" style={{
      background: '#2C003E'
    }}>
      <SEOHead
        title="The Children's Hour Academy | Preschool in Lake Oswego, OR"
        description="SPARK 5-Star preschool and childcare in Lake Oswego, OR. Infant through kindergarten programs with Creative Curriculum and S.T.E.A.M. Schedule a tour today."
        canonicalPath="/"
      />
      <Header />
      <main className="pt-[120px] sm:pt-[150px] md:pt-[170px] lg:pt-[194px]">
        <HomeHero />
        <section className="py-10" style={{
          background: 'linear-gradient(180deg, #2C003E 0%, #5E2DB4 50%, #7C3AED 100%)',
          opacity: 1
        }}>
          <div className="space-y-12">
            <Hero />
            <SparkSection />
            <AboutSection />
            <PoemSection />
          </div>
        </section>
        <ProgramsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
